'use client';

import { useCallback } from 'react';
import { Box, VStack, HStack } from '@terra/ui-styled-system';
import { MarkdownPreview, Text, IconButton } from '@terra/ui-design-system';
import { Cancel01Icon } from '@terra/ui-icons';
import { useMainContentTabs } from '../../store/layoutStore';
import type { Tab } from '../../store/layoutStore';

type NodeArgsViewerTabProps = {
  tab: Tab;
};

export function NodeArgsViewerTab({ tab }: NodeArgsViewerTabProps) {
  const { closeTab } = useMainContentTabs();
  const tabData = tab.data as {
    nodeName: string;
    nodePayload: string;
  };
  const handleClose = useCallback(() => {
    closeTab(tab.id);
  }, [closeTab, tab.id]);

  return (
    <Box h="full" w="full" overflow="hidden">
      <VStack gap={4} height="100%" p={4}>
        <HStack justifyContent="space-between" alignItems="center" width="100%">
          <Text fontSize="lg" fontWeight="semibold">
            Node <strong>{tabData.nodeName}</strong> Arguments
          </Text>
          <IconButton aria-label="Close" variant="ghost" onClick={handleClose}>
            <Cancel01Icon />
          </IconButton>
        </HStack>
        <VStack flex={1} width="100%" overflow="auto">
          <MarkdownPreview source={tabData.nodePayload} />
        </VStack>
      </VStack>
    </Box>
  );
}
